/**
 * 댓글 카테고리 표시 메타(이모지·라벨) SSOT (JCG-3603 / JCG-2706).
 *
 * `CommentSection`(4탭)·`ForumCommentSection`(3탭)·`/my/comments` 필터·배지가 모두 이 모듈을 소비한다.
 * 카테고리를 추가하면 `CommentCategory`(`src/lib/types.ts`)·이 메타·`/api/cron/reclassify-comments` 의
 * 카테고리 맵을 함께 갱신한다(`.claude/docs/ui-patterns/comments.md` §1 규칙). 탭 순서·부분집합은
 * 각 소비처가 `toCommentTabs([...])` 에 넘기는 키 배열로 정한다.
 */
import type { CommentCategory } from "@/lib/types";

export interface CommentCategoryMeta {
  label: string;
  emoji: string;
}

export const COMMENT_CATEGORY_META: Record<CommentCategory, CommentCategoryMeta> = {
  chat: { label: "잡담", emoji: "💬" },
  question: { label: "질문", emoji: "❓" },
  bug: { label: "버그", emoji: "🐛" },
  suggestion: { label: "제안", emoji: "💡" },
};

/** 전체 카테고리의 기본 표시 순서(일반 글 댓글 탭·내 댓글 필터). */
export const COMMENT_CATEGORY_ORDER: readonly CommentCategory[] = [
  "chat",
  "question",
  "bug",
  "suggestion",
];

export interface CommentTab extends CommentCategoryMeta {
  key: CommentCategory;
}

/** 탭 키 배열 → `{ key, label, emoji }[]` (섹션별 순서·부분집합을 그대로 유지). */
export function toCommentTabs(keys: readonly CommentCategory[]): CommentTab[] {
  return keys.map((key) => ({ key, ...COMMENT_CATEGORY_META[key] }));
}
